import axios from "../../axios";

const getInventoryAttributes = async () => {
  try {
    const { data } = await axios.get(`/inventory_values/attributes`);
    console.log(data, "attributes");
    return data;
  } catch (e) {
    return [];
  }
};

const getInventoryValues = async (brand) => {
  try {
    const { data } = await axios.get(`/inventory_values/brands/${brand}`);
    return data;
  } catch (e) {
    return [];
  }
};

export { getInventoryAttributes, getInventoryValues };